import { WebAdAdapter } from '@apm/bloom-receiver-sdk';
import type { AdAdapter, AdItem, AdRequest } from '@apm/bloom-receiver-sdk';
import { adsEnabled } from './ads-enabled.js';

/**
 * 광고 어댑터를 만든다 — **데코레이터 하나가 설정 토글의 전부다** (v21, `docs/45` §9.8).
 *
 * ★ **`ReceiverOptions.ads` 를 조건부로 주입하지 않는다.** 그것은 생성자 인자라,
 * 토글 한 번에 리시버를 다시 세워야 하고 그러면 **영상이 처음부터 다시 시작한다**
 * (절대 규칙 25·51). 언제나 주입하고, **꺼져 있으면 어댑터가 빈 배열을 낸다.**
 *
 * ★ **호출 시점에 읽는다.** 생성 시점에 `adsEnabled()` 를 읽어 두면 토글이 **다음 채널
 * 전환까지 안 먹는다** — 그리고 그 증상은 「껐는데 광고가 나온다」 하나다.
 *
 * **빈 배열은 no fill 과 같은 길이다.** 코어에 새 분기가 없다 — `openBreak` 이 이미
 * 「채울 것이 없으면 브레이크가 없었던 것처럼 흐른다」로 처리한다 (`docs/45` §8.7).
 *
 * **코어는 0줄이다.** 광고를 끄는 일이 코어의 관심사가 아니라는 것이 이 설계의 요점이다.
 */
export function createAdAdapter(inner: AdAdapter = new WebAdAdapter()): AdAdapter {
  return {
    async requestAds(req: AdRequest, opts: { timeoutMs: number }): Promise<AdItem[]> {
      // **여기서 읽는 것이 계약이다.** 위 ★ 참조.
      if (!adsEnabled()) return [];
      return inner.requestAds(req, opts);
    },
    track(urls: readonly string[]): void {
      // 꺼져 있으면 쏠 것도 없다 — 애초에 광고가 나가지 않았다.
      if (!adsEnabled()) return;
      inner.track(urls);
    },
  };
}
